import ReceiveOnly from "./ReceiveOnly";

export default ReceiveOnly;